export const COUNTRIES_WITH_SUBSCRIPTION_TERMS = [
  'pl',
]

export const SUBSCRIPTION_OFFER_ENTRY_SOURCE_QUERY_KEY = 'entry_source'

export const SUBSCRIPTION_OFFER_ENTRY_SOURCES = {
  PLAN_INFO_MODAL: 'plan_info_modal',
  SIDE_MENU: 'side_menu',
} as const
